import { Theme } from "@/enums";

export const getTextClass = ({
  isActive,
  theme,
}: {
  isActive: boolean;
  theme: string;
}) => {
  if (isActive) {
    return theme === Theme.GEORGIA || theme === Theme.UZ
      ? "text-[#018b9d]"
      : "text-[#eb7623]";
  }
  return "text-[#121212]";
};
